var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleWhereBuyPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 392,
    viewBox: "0 0 396 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_7452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 396,
    height: 392
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 392,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_7452)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_7452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.327 226.182C356.887 238.342 354.287 249.848 347.527 251.887C340.762 253.924 332.395 245.721 328.838 233.566C325.279 221.406 327.879 209.9 334.639 207.861C341.404 205.824 349.771 214.028 353.327 226.182Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.283 305.89C336.504 309.152 347.1 301.298 352.95 288.347C358.799 275.396 357.688 262.253 350.467 258.992C343.246 255.73 332.65 263.585 326.8 276.535C320.95 289.486 322.062 302.629 329.283 305.89Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.0054 48.937L-60.7206 91.6993C-55.9477 96.2623 -49.5399 100.054 -41.9626 102.42C-21.5524 108.797 -0.410856 102.411 5.26132 88.1564C10.9335 73.902 -1.01372 57.1766 -21.4256 50.8048C-29.5086 48.2781 -37.7052 47.762 -45.0115 48.9398L-45.0054 48.937Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.7637 16.6485C-32.4105 29.8009 -21.4031 45.6829 -3.17802 52.1218C15.0471 58.5608 33.5884 53.1185 38.2352 39.966C42.882 26.8136 31.8746 10.9316 13.6495 4.49265C-4.57565 -1.94631 -23.1169 3.49605 -27.7637 16.6485Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7009 138.101C54.0304 148.863 75.1968 147.716 81.9775 135.537C88.7582 123.359 78.5854 104.762 59.2559 93.9997C39.9265 83.2374 18.76 84.3852 11.9793 96.5635C5.19867 108.742 15.3715 127.339 34.7009 138.101Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8793 89.2907C80.0988 100.687 99.6638 101.456 106.579 91.0074C113.494 80.5588 105.141 62.8499 87.9219 51.4532C70.7024 40.0566 51.1373 39.2881 44.222 49.7366C37.3067 60.1851 45.6599 77.8941 62.8793 89.2907Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.453 142.803C123.182 158.827 138.95 167.033 148.672 161.13C158.395 155.227 158.391 137.452 148.663 121.428C138.934 105.403 123.166 97.198 113.443 103.101C103.721 109.003 103.725 126.779 113.453 142.803Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0043 179.418C92.558 193.732 108.044 200.168 117.594 193.794C127.143 187.42 127.14 170.65 117.586 156.336C108.033 142.023 92.5464 135.586 82.9968 141.96C73.4472 148.334 73.4505 165.105 83.0043 179.418Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.374 230.48C116.381 244.719 129.205 252.907 139.018 248.768C148.831 244.629 151.916 229.73 145.909 215.49C139.902 201.25 127.078 193.062 117.265 197.201C107.452 201.34 104.367 216.24 110.374 230.48Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.359 200.452C148.862 213.984 160.08 222.205 168.415 218.816C176.75 215.426 179.045 201.708 173.542 188.176C168.039 174.645 156.821 166.423 148.486 169.813C140.151 173.203 137.855 186.921 143.359 200.452Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.125 220.777C276.394 224.409 280.154 225.665 281.517 223.574C282.881 221.483 281.333 216.844 278.063 213.212C274.794 209.58 271.035 208.324 269.671 210.415C268.308 212.506 269.856 217.145 273.125 220.777Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 285.794C143.593 296.989 156.202 301.685 163.918 296.282C171.633 290.879 171.532 277.424 163.693 266.229C155.854 255.034 143.244 250.339 135.529 255.741C127.814 261.144 127.914 274.599 135.754 285.794Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 285.794C143.593 296.989 156.202 301.685 163.918 296.282C171.633 290.879 171.532 277.424 163.693 266.229C155.854 255.034 143.244 250.339 135.529 255.741C127.814 261.144 127.914 274.599 135.754 285.794Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.015 239.51C283.628 245.151 287.02 248.476 289.592 246.94C292.159 245.402 292.935 239.585 291.322 233.944C289.709 228.304 286.316 224.979 283.746 226.511C281.179 228.048 280.403 233.865 282.016 239.506L282.015 239.51Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.101 259.202C276.003 264.679 276.712 269.377 279.687 269.694C282.662 270.01 286.777 265.824 288.88 260.349C290.978 254.872 290.269 250.174 287.294 249.857C284.319 249.541 280.204 253.727 278.101 259.202Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.338 275.267C251.765 279.71 248.202 285.864 251.386 289.016C254.569 292.168 263.29 291.121 270.866 286.684C278.439 282.241 282.002 276.087 278.818 272.935C275.635 269.783 266.914 270.83 259.338 275.267Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 290.414C210.412 285.627 204.191 277.073 206.818 271.311C209.44 265.548 219.917 264.758 230.209 269.549C240.502 274.335 246.723 282.89 244.101 288.653C241.478 294.417 231.002 295.206 220.71 290.415L220.705 290.414Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.196 243.5C186.111 231.079 191.654 220.922 198.582 220.816C205.508 220.714 211.193 230.7 211.28 243.127C211.365 255.549 205.822 265.705 198.894 265.812C191.968 265.914 186.284 255.928 186.196 243.5Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.665 339.138C278.021 344.775 291.073 341.988 302.819 332.913C314.564 323.837 320.555 311.911 316.2 306.274C311.845 300.637 298.792 303.424 287.046 312.499C275.301 321.575 269.31 333.501 273.665 339.138Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.921 357.855C231.993 357.976 220.585 351.091 220.442 342.465C220.297 333.844 231.47 326.755 245.399 326.629C259.327 326.508 270.735 333.394 270.878 342.019C271.023 350.64 259.85 357.729 245.921 357.855Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.429 328.8C168.736 318.799 165.857 305.789 172 299.736C178.142 293.683 190.983 296.889 200.678 306.886C210.371 316.888 213.25 329.898 207.107 335.951C200.964 342.004 188.123 338.798 178.429 328.8Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.439 184.605C328.375 193.235 332.298 203.733 328.192 208.059C324.086 212.385 313.514 208.893 304.571 200.266C295.635 191.636 291.712 181.138 295.818 176.812C299.924 172.486 310.496 175.978 319.439 184.605Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.838 157.843C276.139 156.095 286.831 159.455 287.716 165.347C288.606 171.242 279.353 177.443 267.052 179.19C254.75 180.938 244.058 177.579 243.173 171.686C242.283 165.792 251.536 159.59 263.838 157.843Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.377 184.713C214.657 174.646 225.138 169.743 230.784 173.754C236.429 177.77 235.103 189.184 227.823 199.252C220.543 209.32 210.062 214.223 204.416 210.211C198.771 206.195 200.096 194.781 207.377 184.713Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.527 251.887C340.762 253.924 332.395 245.721 328.839 233.566C325.279 221.406 327.879 209.9 334.639 207.861",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.527 251.887C340.762 253.924 332.395 245.721 328.839 233.566C325.279 221.406 327.879 209.9 334.639 207.861",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.366 305.929C322.107 302.752 320.927 289.661 326.732 276.691C332.533 263.719 343.121 255.779 350.38 258.957",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.366 305.929C322.107 302.752 320.927 289.661 326.732 276.691C332.533 263.719 343.121 255.779 350.38 258.957",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.7637 16.6485C-32.4105 29.801 -21.4031 45.6829 -3.17802 52.1219C15.0471 58.5608 33.5884 53.1185 38.2352 39.966C42.882 26.8136 31.8746 10.9316 13.6495 4.49268C-4.57565 -1.94628 -23.1169 3.49608 -27.7637 16.6485Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6889 138.099C15.3572 127.333 5.18601 108.739 11.966 96.5609L34.6889 138.099Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6889 138.099C15.3572 127.333 5.18601 108.739 11.966 96.5609",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8793 89.2907C80.0988 100.687 99.6638 101.456 106.579 91.0074C113.494 80.5589 105.141 62.8499 87.9219 51.4533C70.7024 40.0567 51.1373 39.2881 44.222 49.7366C37.3067 60.1851 45.6599 77.8941 62.8793 89.2907Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.684 161.137C138.96 167.039 123.19 158.838 113.461 142.812C103.731 126.79 103.729 109.013 113.452 103.111",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.684 161.137C138.96 167.039 123.19 158.838 113.461 142.812C103.731 126.79 103.729 109.013 113.452 103.111",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1694 179.667C73.5249 165.417 73.3724 148.583 82.8358 142.071L83.1694 179.667Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1694 179.667C73.5249 165.417 73.3724 148.583 82.8358 142.071",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.374 230.48C116.381 244.719 129.205 252.908 139.018 248.768C148.831 244.629 151.916 229.73 145.909 215.49C139.902 201.25 127.078 193.062 117.265 197.201C107.452 201.341 104.367 216.24 110.374 230.48Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.512 169.808C156.859 166.445 168.074 174.692 173.559 188.226L148.512 169.808Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.512 169.808C156.859 166.445 168.074 174.692 173.559 188.226",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.511 223.577C282.875 221.486 281.327 216.847 278.057 213.215C274.788 209.583 271.029 208.327 269.665 210.418",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.511 223.577C282.875 221.486 281.327 216.847 278.057 213.215C274.788 209.583 271.029 208.327 269.665 210.418",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.039 296.175C156.408 301.696 143.797 297.137 135.879 285.997L164.039 296.175Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.039 296.175C156.408 301.696 143.797 297.137 135.879 285.997",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.592 246.94C292.159 245.402 292.935 239.585 291.322 233.944L289.592 246.94Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.592 246.94C292.159 245.402 292.935 239.585 291.322 233.944",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.691 269.695C282.666 270.012 286.781 265.826 288.884 260.351L279.691 269.695Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.691 269.695C282.666 270.012 286.781 265.826 288.884 260.351",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.386 289.016C254.569 292.168 263.29 291.121 270.866 286.684L251.386 289.016Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.386 289.016C254.569 292.168 263.29 291.121 270.866 286.684",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 290.414C210.412 285.627 204.191 277.073 206.818 271.311L220.705 290.414Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 290.414C210.412 285.627 204.191 277.073 206.818 271.311",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.196 243.5C186.111 231.079 191.654 220.922 198.582 220.816C205.508 220.714 211.193 230.7 211.28 243.127C211.365 255.549 205.822 265.705 198.894 265.812C191.968 265.914 186.284 255.928 186.196 243.5Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92 332.826C291.198 341.932 278.114 344.779 273.699 339.188L302.92 332.826Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92 332.826C291.198 341.932 278.114 344.779 273.699 339.188",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.921 357.855C231.993 357.976 220.585 351.091 220.442 342.465L245.921 357.855Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.921 357.855C231.993 357.976 220.585 351.091 220.442 342.465",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.107 335.951C200.964 342.004 188.123 338.798 178.429 328.8C168.736 318.799 165.857 305.789 172 299.736",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.107 335.951C200.964 342.004 188.123 338.798 178.429 328.8C168.736 318.799 165.857 305.789 172 299.736",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.571 200.266C295.635 191.636 291.712 181.138 295.818 176.812C299.924 172.486 310.496 175.978 319.439 184.605",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.571 200.266C295.635 191.636 291.712 181.138 295.818 176.812C299.924 172.486 310.496 175.978 319.439 184.605",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.838 157.843C276.139 156.095 286.831 159.455 287.716 165.347C288.606 171.242 279.353 177.443 267.052 179.19C254.75 180.938 244.058 177.579 243.173 171.686C242.283 165.792 251.536 159.59 263.838 157.843Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.416 210.211C198.771 206.195 200.096 194.781 207.377 184.713L204.416 210.211Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.416 210.211C198.771 206.195 200.096 194.781 207.377 184.713",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.327 226.182C356.887 238.342 354.287 249.848 347.527 251.887C340.762 253.924 332.395 245.721 328.838 233.566C325.279 221.406 327.879 209.9 334.639 207.861C341.404 205.824 349.771 214.028 353.327 226.182Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.283 305.89C336.504 309.152 347.1 301.298 352.95 288.347C358.799 275.396 357.688 262.253 350.467 258.992C343.246 255.73 332.65 263.585 326.8 276.535C320.95 289.486 322.062 302.629 329.283 305.89Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6078 13.0713C-19.2917 11.9419 -26.0799 12.2864 -32.0818 13.7569L-64.9424 103.174C-59.8582 108.728 -54.7179 113.966 -52.803 114.67C-52.803 114.67 -43.8148 111.22 -32.7699 115.279C-21.725 119.338 24.4017 138.221 35.0505 145.993C45.6994 153.764 86.3392 192.819 99.3753 218.835C112.411 244.852 126.693 289.132 138.694 311.571C144.672 322.749 176.321 351.813 190.185 354.472C204.048 357.131 224.843 367.209 238.994 372.41C253.144 377.61 270.103 367.443 283.973 371.224C297.843 375.005 329.956 330.588 332.089 327.514C334.226 324.442 362.521 286.6 368.456 282.992C374.391 279.384 372.069 219.095 361.274 203.172C350.48 187.248 294.695 143.01 285.765 139.728C276.834 136.447 240.107 133.443 220.352 151.383C200.597 169.322 181.529 175.295 175.635 211.162C170.727 241.023 171.646 248.39 174.615 261.524C166.152 239.422 157.557 209.884 148.845 170.384C127.451 73.3484 49.713 22.1019 -11.6078 13.0713ZM203.569 230.641C208.919 185.416 241.459 169.75 277.916 174.464C314.369 179.177 332.296 207.555 341.356 228.252C350.417 248.95 342.32 283.085 319.006 308.279C295.691 333.478 250.874 337.764 218.416 323.017C206.769 317.728 194.76 306.043 182.453 279.992C197.827 295.667 238.505 308.079 260.728 309C287.349 310.099 291.028 292.157 308.346 254.144C325.664 216.132 255.816 195.712 255.816 195.712C255.696 193.666 252.474 199.179 259.99 204.321C275.724 215.091 279.121 223.767 283.995 234.136C288.591 243.914 282.78 272.308 246.541 278.829C214.075 284.674 201.597 247.355 203.575 230.639L203.569 230.641Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.937 341.896C139.491 320.709 100.973 211.304 68.1694 182.501C40.959 158.608 -30.6582 127.866 -64.5646 125.789C-56.8111 135.552 -46.8641 143.504 -38.0139 146.015C-0.988795 156.525 41.344 173.56 71.1453 209.696C103.842 249.342 110.031 275.959 131.305 308.815C147.341 333.584 190.822 374.268 243.168 379.067C219.528 372.573 187.911 361.029 164.937 341.896Z",
    fill: "#D16984",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6078 13.0713C-19.2917 11.9419 -26.0799 12.2864 -32.0818 13.7569L-64.9424 103.174C-59.8582 108.728 -54.7179 113.966 -52.803 114.67C-52.803 114.67 -43.8148 111.22 -32.7699 115.279C-21.725 119.338 24.4017 138.221 35.0505 145.993C45.6994 153.764 86.3392 192.819 99.3753 218.835C112.411 244.852 126.693 289.132 138.694 311.571C144.672 322.749 176.321 351.813 190.185 354.472C204.048 357.131 224.843 367.209 238.994 372.41C253.144 377.61 270.103 367.443 283.973 371.224C297.843 375.005 329.956 330.588 332.089 327.514C334.226 324.442 362.521 286.6 368.456 282.992C374.391 279.384 372.069 219.095 361.274 203.172C350.48 187.248 294.695 143.01 285.765 139.728C276.834 136.447 240.107 133.443 220.352 151.383C200.597 169.322 181.529 175.295 175.635 211.162C170.727 241.023 171.646 248.39 174.615 261.524C166.152 239.422 157.557 209.884 148.845 170.384C127.451 73.3484 49.713 22.1019 -11.6078 13.0713ZM203.569 230.641C208.919 185.416 241.459 169.75 277.916 174.464C314.369 179.177 332.296 207.555 341.356 228.252C350.417 248.95 342.32 283.085 319.006 308.279C295.691 333.478 250.874 337.764 218.416 323.017C206.769 317.728 194.76 306.043 182.453 279.992C197.827 295.667 238.505 308.079 260.728 309C287.349 310.099 291.028 292.157 308.346 254.144C325.664 216.132 255.816 195.712 255.816 195.712C255.696 193.666 252.474 199.179 259.99 204.321C275.724 215.091 279.121 223.767 283.995 234.136C288.591 243.914 282.78 272.308 246.541 278.829C214.075 284.674 201.597 247.355 203.575 230.639L203.569 230.641Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.756 161.866C124.071 231.608 165.939 286.888 204.199 305.785C236.006 321.493 279.364 338.042 307.497 284.216C350.322 202.278 247.976 190.204 255.807 195.709C277.308 210.837 289.048 210.012 297.535 239.39C303.532 260.151 277.532 304.111 234.24 297.551C183.606 289.876 174.85 222.916 198.132 190.343C221.414 157.769 277.062 129.349 326.107 186.385C366.633 233.517 352.266 272.61 326.133 313.011C308.958 339.559 283.187 365.403 243.417 360.964C213.253 357.594 170.653 365.575 108.655 224.172C93.0232 188.518 42.6034 125.495 -16.1356 114.64C-40.2805 110.179 -54.6174 103.922 -63.2509 98.5708L-70.2521 117.622C-62.2135 130.904 -49.2397 142.832 -38.0199 146.018C-0.994887 156.528 41.3379 173.563 71.1392 209.699C103.836 249.345 110.798 275.479 131.299 308.818C158.439 352.952 236.241 408.786 310.737 376.723C424.335 327.824 398.768 196.119 338.222 150.716C283.152 109.419 229.926 125.673 193.76 161.868L193.756 161.866Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.756 161.866C124.071 231.608 165.939 286.888 204.199 305.785C236.006 321.493 279.364 338.042 307.497 284.216C350.322 202.278 247.976 190.204 255.807 195.709C277.308 210.837 289.048 210.012 297.535 239.39C303.532 260.151 277.532 304.111 234.24 297.551C183.606 289.876 174.85 222.916 198.132 190.343C221.414 157.769 277.062 129.349 326.107 186.385C366.633 233.517 352.266 272.61 326.133 313.011C308.958 339.559 283.187 365.403 243.417 360.964C213.253 357.594 170.653 365.575 108.655 224.172C93.0232 188.518 42.6034 125.495 -16.1356 114.64C-40.2805 110.179 -54.6174 103.922 -63.2509 98.5708L-70.2521 117.622C-62.2135 130.904 -49.2397 142.832 -38.0199 146.018C-0.994887 156.528 41.3379 173.563 71.1392 209.699C103.836 249.345 110.798 275.479 131.299 308.818C158.439 352.952 236.241 408.786 310.737 376.723C424.335 327.824 398.768 196.119 338.222 150.716C283.152 109.419 229.926 125.673 193.76 161.868L193.756 161.866Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.756 161.866C124.071 231.608 165.939 286.888 204.199 305.785C236.006 321.493 279.364 338.042 307.497 284.216C350.322 202.278 247.976 190.204 255.807 195.709C277.308 210.837 289.048 210.012 297.535 239.39C303.532 260.151 277.532 304.111 234.24 297.551C183.606 289.876 174.85 222.916 198.132 190.343C221.414 157.769 277.062 129.349 326.107 186.385C366.633 233.517 352.266 272.61 326.133 313.011C308.958 339.559 283.187 365.403 243.417 360.964C213.253 357.594 170.653 365.575 108.655 224.172C93.0232 188.518 42.6034 125.495 -16.1356 114.64C-40.2805 110.179 -54.6174 103.922 -63.2509 98.5708L-70.2521 117.622C-62.2135 130.904 -49.2397 142.832 -38.0199 146.018C-0.994887 156.528 41.3379 173.563 71.1392 209.699C103.836 249.345 110.798 275.479 131.299 308.818C158.439 352.952 236.241 408.786 310.737 376.723C424.335 327.824 398.768 196.119 338.222 150.716C283.152 109.419 229.926 125.673 193.76 161.868L193.756 161.866Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.0054 48.937L-60.7206 91.6993C-55.9477 96.2623 -49.5399 100.054 -41.9626 102.42C-21.5524 108.797 -0.410856 102.411 5.26132 88.1564C10.9335 73.902 -1.01372 57.1766 -21.4256 50.8048C-29.5086 48.2781 -37.7052 47.762 -45.0115 48.9398L-45.0054 48.937Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.7637 16.6485C-32.4105 29.8009 -21.4031 45.6829 -3.17802 52.1218C15.0471 58.5608 33.5884 53.1185 38.2352 39.966C42.882 26.8136 31.8746 10.9316 13.6495 4.49265C-4.57565 -1.94631 -23.1169 3.49605 -27.7637 16.6485Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1507 22.2449C-14.6787 29.4004 -8.68953 38.0411 1.22656 41.5444C11.1427 45.0478 21.2306 42.0872 23.7586 34.9317C26.2867 27.7763 20.2975 19.1356 10.3814 15.6322C0.465298 12.1288 -9.62265 15.0895 -12.1507 22.2449Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.701 138.101C54.0305 148.863 75.1969 147.716 81.9776 135.537C88.7583 123.359 78.5855 104.762 59.256 93.9997C39.9266 83.2373 18.7601 84.3852 11.9795 96.5634C5.19879 108.742 15.3716 127.339 34.701 138.101Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9111 128.438C51.4289 134.294 62.946 133.67 66.6351 127.044C70.3243 120.418 64.7886 110.3 54.2708 104.444C43.753 98.5874 32.236 99.2114 28.5468 105.837C24.8576 112.463 30.3933 122.582 40.9111 128.438Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8792 89.2907C80.0986 100.687 99.6637 101.456 106.579 91.0073C113.494 80.5588 105.141 62.8498 87.9217 51.4532C70.7023 40.0566 51.1372 39.2881 44.2219 49.7366C37.3066 60.1851 45.6598 77.8941 62.8792 89.2907Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1314 81.0723C78.5009 87.2734 89.1466 87.6916 92.9094 82.0063C96.6722 76.3209 92.1272 66.6851 82.7577 60.484C73.3883 54.2829 62.7425 53.8647 58.9797 59.55C55.2169 65.2353 59.762 74.8712 69.1314 81.0723Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.453 142.803C123.182 158.827 138.95 167.033 148.672 161.13C158.395 155.227 158.391 137.452 148.663 121.428C138.934 105.403 123.166 97.198 113.443 103.101C103.721 109.003 103.725 126.779 113.453 142.803Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.765 138.475C127.057 147.192 135.637 151.655 140.928 148.442C146.22 145.23 146.219 135.559 140.927 126.842C135.635 118.125 127.055 113.662 121.764 116.875C116.472 120.087 116.473 129.758 121.765 138.475Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0043 179.418C92.558 193.732 108.044 200.168 117.594 193.794C127.143 187.42 127.14 170.65 117.586 156.336C108.033 142.023 92.5464 135.586 82.9968 141.96C73.4472 148.334 73.4505 165.105 83.0043 179.418Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.174 174.642C96.3724 182.43 104.799 185.932 109.996 182.464C115.193 178.995 115.191 169.87 109.993 162.081C104.794 154.293 96.3673 150.791 91.1706 154.259C85.974 157.728 85.9755 166.853 91.174 174.642Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.374 230.48C116.381 244.719 129.205 252.907 139.018 248.768C148.831 244.629 151.916 229.73 145.909 215.49C139.902 201.25 127.078 193.062 117.265 197.201C107.452 201.34 104.367 216.24 110.374 230.48Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.648 227.545C121.916 235.294 128.893 239.75 134.23 237.499C139.568 235.247 141.245 227.14 137.977 219.392C134.708 211.643 127.731 207.187 122.394 209.439C117.056 211.69 115.379 219.797 118.648 227.545Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.359 200.452C148.862 213.984 160.08 222.205 168.415 218.815C176.75 215.426 179.045 201.708 173.542 188.176C168.039 174.645 156.821 166.423 148.486 169.813C140.151 173.203 137.855 186.92 143.359 200.452Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.24 199.545C146.918 192.878 146.746 185.316 150.859 182.662C154.971 180.008 161.81 183.257 166.137 189.926C170.459 196.593 170.63 204.154 166.518 206.808C162.406 209.463 155.567 206.213 151.24 199.545Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.125 220.777C276.394 224.409 280.154 225.665 281.517 223.574C282.881 221.483 281.333 216.844 278.063 213.212C274.794 209.58 271.035 208.324 269.671 210.415C268.308 212.506 269.856 217.145 273.125 220.777Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.771 218.569C274.4 220.862 276.164 222.141 276.716 221.421C277.268 220.701 276.396 218.257 274.767 215.965C273.139 213.672 271.375 212.393 270.823 213.113C270.271 213.833 271.143 216.277 272.771 218.569Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 285.794C143.593 296.989 156.202 301.685 163.918 296.282C171.633 290.879 171.532 277.424 163.693 266.229C155.854 255.034 143.244 250.339 135.529 255.741C127.814 261.144 127.914 274.599 135.754 285.794Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.419 281.825C138.111 275.764 137.983 268.415 142.137 265.413C146.291 262.411 153.151 264.891 157.459 270.953C161.767 277.014 161.895 284.363 157.741 287.365C153.587 290.367 146.727 287.886 142.419 281.825Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 285.794C143.593 296.989 156.202 301.685 163.918 296.282C171.633 290.879 171.532 277.424 163.693 266.229C155.854 255.034 143.244 250.339 135.529 255.741C127.814 261.144 127.914 274.599 135.754 285.794Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.419 281.825C138.111 275.764 137.983 268.415 142.137 265.413C146.291 262.411 153.151 264.891 157.459 270.953C161.767 277.014 161.895 284.363 157.741 287.365C153.587 290.367 146.727 287.886 142.419 281.825Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.015 239.51C283.628 245.151 287.02 248.476 289.592 246.94C292.159 245.402 292.935 239.585 291.322 233.944C289.709 228.304 286.316 224.979 283.746 226.511C281.179 228.048 280.403 233.865 282.016 239.506L282.015 239.51Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 236.941C283.35 240.268 284.584 242.578 285.556 242.088C286.526 241.602 286.872 238.507 286.325 235.179C285.777 231.851 284.543 229.542 283.572 230.032C282.601 230.518 282.256 233.613 282.803 236.941Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.101 259.202C276.003 264.679 276.712 269.377 279.687 269.694C282.662 270.01 286.777 265.824 288.88 260.349C290.978 254.872 290.269 250.174 287.294 249.857C284.319 249.541 280.204 253.727 278.101 259.202Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.092 258.936C277.883 262.087 277.786 264.699 278.867 264.774C279.951 264.844 281.812 262.346 283.021 259.194C284.229 256.043 284.327 253.431 283.243 253.361C282.16 253.29 280.299 255.789 279.09 258.94L279.092 258.936Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.338 275.267C251.765 279.71 248.202 285.864 251.386 289.016C254.569 292.168 263.29 291.121 270.866 286.684C278.439 282.241 282.002 276.087 278.818 272.935C275.635 269.783 266.914 270.83 259.338 275.267Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.738 275.877C256.38 278.431 253.819 281.393 255.024 282.491C256.225 283.588 260.734 282.406 265.091 279.852C269.449 277.298 272.01 274.336 270.805 273.238C269.604 272.141 265.097 273.318 260.738 275.877Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 290.414C210.412 285.627 204.191 277.073 206.818 271.311C209.44 265.548 219.917 264.758 230.209 269.549C240.502 274.335 246.723 282.89 244.101 288.653C241.478 294.417 231.002 295.206 220.71 290.415L220.705 290.414Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.426 283.232C220.822 280.628 217.44 275.971 218.868 272.84C220.298 269.704 225.993 269.275 231.596 271.88C237.2 274.484 240.582 279.14 239.154 282.272C237.724 285.407 232.03 285.836 226.426 283.232Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.196 243.5C186.111 231.079 191.654 220.922 198.582 220.816C205.508 220.714 211.193 230.7 211.28 243.127C211.365 255.549 205.822 265.705 198.894 265.812C191.968 265.914 186.284 255.928 186.196 243.5Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14 243.893C194.093 237.134 197.113 231.607 200.879 231.554C204.647 231.496 207.743 236.931 207.786 243.689C207.833 250.449 204.814 255.975 201.048 256.028C197.28 256.086 194.183 250.652 194.14 243.893Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.665 339.138C278.021 344.775 291.073 341.988 302.819 332.913C314.564 323.837 320.555 311.911 316.2 306.274C311.845 300.637 298.792 303.424 287.046 312.499C275.301 321.575 269.31 333.501 273.665 339.138Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.005 325.554C290.626 330.507 283.506 332.056 281.108 329.016C278.706 325.975 281.93 319.494 288.308 314.542C294.687 309.589 301.803 308.038 304.205 311.08C306.607 314.121 303.384 320.601 297.005 325.554Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.921 357.855C231.993 357.976 220.585 351.091 220.442 342.465C220.297 333.844 231.47 326.755 245.399 326.629C259.327 326.508 270.735 333.394 270.878 342.019C271.023 350.64 259.85 357.729 245.921 357.855Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.601 346.512C238.022 346.581 231.815 342.832 231.739 338.14C231.663 333.447 237.739 329.593 245.319 329.525C252.898 329.456 259.105 333.204 259.181 337.897C259.257 342.589 253.181 346.443 245.601 346.512Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.429 328.8C168.736 318.799 165.857 305.789 172 299.736C178.142 293.683 190.983 296.889 200.678 306.886C210.371 316.888 213.25 329.898 207.107 335.951C200.964 342.004 188.123 338.798 178.429 328.8Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.426 320.746C181.155 315.304 179.585 308.227 182.929 304.932C186.271 301.642 193.257 303.382 198.533 308.826C203.805 314.268 205.374 321.345 202.03 324.64C198.688 327.93 191.703 326.19 186.426 320.746Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.439 184.605C328.375 193.235 332.298 203.733 328.192 208.059C324.086 212.385 313.514 208.893 304.571 200.266C295.635 191.636 291.712 181.138 295.818 176.812C299.924 172.486 310.496 175.978 319.439 184.605Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.143 192.544C318.008 197.241 320.14 202.952 317.904 205.302C315.673 207.654 309.916 205.755 305.054 201.064C300.19 196.366 298.057 190.656 300.293 188.305C302.524 185.953 308.281 187.852 313.143 192.544Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.838 157.843C276.139 156.095 286.831 159.455 287.716 165.347C288.606 171.242 279.353 177.443 267.052 179.19C254.75 180.938 244.058 177.579 243.173 171.686C242.283 165.792 251.536 159.59 263.838 157.843Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.229 167.693C272.922 166.744 278.736 168.568 279.221 171.777C279.706 174.986 274.671 178.355 267.976 179.308C261.284 180.258 255.464 178.432 254.984 175.225C254.499 172.016 259.534 168.647 266.229 167.693Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.377 184.713C214.657 174.646 225.138 169.743 230.784 173.754C236.429 177.77 235.103 189.184 227.823 199.252C220.543 209.32 210.062 214.223 204.416 210.211C198.771 206.195 200.096 194.781 207.377 184.713Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.551 189.731C217.511 184.252 223.217 181.583 226.286 183.77C229.357 185.953 228.636 192.168 224.673 197.641C220.713 203.119 215.012 205.79 211.938 203.601C208.867 201.419 209.588 195.203 213.551 189.731Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.912 311.753C221.42 321.882 250.026 326.388 272.964 318.121C246.476 314.534 200.97 304.583 186.054 277.821C166.901 243.449 172.956 200.405 199.259 156.647C197.404 158.32 195.566 160.055 193.76 161.868C124.076 231.609 162.652 292.856 200.916 311.754L200.912 311.753Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.937 341.896C139.491 320.709 100.973 211.304 68.1694 182.501C40.959 158.608 -30.6582 127.866 -64.5646 125.789C-56.8111 135.552 -46.8641 143.504 -38.0139 146.015C-0.988795 156.525 41.344 173.56 71.1453 209.696C103.842 249.342 110.031 275.959 131.305 308.815C147.341 333.584 190.822 374.268 243.168 379.067C219.528 372.573 187.911 361.029 164.937 341.896Z",
    fill: "#D16984"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_7452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283.022,
    height: 494.83,
    fill: "white",
    transform: "translate(438.526 159.948) rotate(110.178)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleWhereBuyPage);
export default __webpack_public_path__ + "static/media/tentacle_where_buy_page.404b061adbd1f8eef4d71b9a1e9fc586.svg";
export { ForwardRef as ReactComponent };